import React, { FC, useEffect, useState } from "react";
import {
  NavPills,
  RelatedOrdersGrid,
  RelatedSubscriptionGrid,
  RelatedPaymentsGrid,
  ItemContentArea,
  DashboardTopRightSide,
  DashboardTopBar,
} from "../../../shared/components";
import { observer } from "mobx-react";
import { Params } from "react-router-dom";
import DetailSection from "./DetailSection";
import {
  CustomLabel,
  FlexContainer,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import {
  ItemsStore,
  OrderStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import {
  OrderRelatedGridModel,
  SelectedItemModel,
} from "../../../shared/models";
import { ItemDetailMainWrapper, MainOuterCard } from "../../../shared/styles";
import { NewPaymentRelatedSource } from "../../../shared/enums";
import { MerchantAccountStore } from "../../merchantAccounts";

type IProps = {
  orderStore: OrderStore;
  params: Readonly<Params<string>>;
  itemStore: ItemsStore;
  merchantAccountStore: MerchantAccountStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

const OrderDetailMain: FC<IProps> = ({
  itemStore,
  merchantAccountStore,
  rolesAndPermissionStore,
  orderStore
}) => {
  const [activeNavPill, setActiveNavPill] = useState("build");

  useEffect(() => {
    itemStore?.setBreadCrumbData(
      new SelectedItemModel({
        route: "/app/items/orders",
        title: "",
        icon: "",
      })
    );

    return () => {
      itemStore?.setBreadCrumbData();
    };
  }, []);

  const navPills = () => {
    return (
      <FlexContainer alignItems="center" padding="0px 0px 30px">
        <CustomLabel color="#2C3E50" fontSize="30px" fontWeight="600">
          Order
        </CustomLabel>
        <div className="flex-auto-grow">
          {true && (
            <NavPills
              defaultActiveKey="build"
              pills={[
                {
                  key: "build",
                  title: "BUILD",
                },
                {
                  key: "preview",
                  title: "PREVIEW",
                },
              ]}
              onSelect={(key) => setActiveNavPill(key)}
            />
          )}
        </div>
      </FlexContainer>
    );
  };

  function renderDetails(node: React.ReactNode, showItemRightContent = true) {
    return (
      <>
        <DashboardTopBar
          itemStore={itemStore}
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
          rightContent={
            <>
               {/* <NavigationButtons
                currentIndex={orderStore.detailPage.index}
                totalItems={orderStore.detailPage.totalPayments}
                previousRecordId={orderStore.detailPage.previousRecordId}
                nextRecordId={orderStore.detailPage.nextRecordId}
                onNavigate={(id) => navigate(`/app/payments/detail/${id}`)}
              />
              {actionDropdown()} */}
            </>
          }
        />
        <ItemContentArea
        //   showLoader={showLoader}
          itemStore={itemStore}
          showMerchantAccountNotificationBar={merchantAccountStore.hasNotificationBar()}
          node={node}
        ></ItemContentArea>
      </>
    );
  }
 

  return renderDetails(
    <ItemDetailMainWrapper>
      <MainOuterCard>
        {navPills()}
        {activeNavPill === "build" && <DetailSection />}
        {/* {activeNavPill === 'build' && renderItems()} */}
      </MainOuterCard>

      {activeNavPill === "build" && (
        <>
          <RelatedOrdersGrid
            orders={[new OrderRelatedGridModel(), new OrderRelatedGridModel()]}
          />
          <RelatedSubscriptionGrid subscriptions={[]} />
          <RelatedPaymentsGrid
            payments={[]}
            source={NewPaymentRelatedSource.Manual}
            sourceId={null}
          />
        </>
      )}
    </ItemDetailMainWrapper>
  );
};
export default withRouter(observer(OrderDetailMain));
